import { useState } from 'react'
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux'
import { CellValueChangedEvent } from '@ag-grid-community/core'
import { Operation } from 'data/types'
import { RootState } from 'data/root.reducers'
import { executeOperationOnList } from 'data/fqdn/fqdn.actions'
import useFqdn from './useFqdn'

export interface DomainFormItem {
    id?: string,
    index: number
    domainName: string
    operation: Operation
}

interface DomainFormParams {
    domainGroup?: string
    domainNames?: DomainFormItem[]
}

export default (params : DomainFormParams = {}) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const { items } = useFqdn();
    const deliveryFunction = useSelector((state: RootState) => state.global.selectedDF)
    const [domainNames, setDomainNames] = useState<DomainFormItem[]>(params?.domainNames || [])
    const [domainGroup, setDomainGroup] = useState({ value: params.domainGroup|| '', hasUpdated: false })

    const handleCellValueChanged = ({ data }: CellValueChangedEvent) => {
        const operation = data.operation === 'NO_OPERATION' ? 'UPDATE' : data.operation
        domainNames[data.index] = { ...data, operation }
        setDomainNames([...domainNames])
    }

    const updateDomainGroup = (value: string) => setDomainGroup({ value, hasUpdated: true })

    const handleClickAddDomainItem = () => setDomainNames([...domainNames, { index: domainNames.length, domainName: '', operation: 'CREATE' }])

    const handleClickSave = () => {
        const domainItems = domainNames.map((domain) => ({
            ...items.find(({ id }) => id === domain.id),
            ...domain,
            fsId: domainGroup.value,
        })).map((item) => {
            const isUpdateOperation = item.operation === 'NO_OPERATION' && domainGroup.hasUpdated;
            item.operation = isUpdateOperation ? 'UPDATE' : item.operation;
            return item;
        });

        dispatch(executeOperationOnList(deliveryFunction, domainItems, history))
    }

    const handleClickRemoveDomainItem = ({ index }: DomainFormItem) => {
        const updatedDomains = domainNames.reduce((acc, item) => {
            if (item.index !== index) {
                return [...acc, item]
            }

            if (item.operation === 'NO_OPERATION'){
                item.operation = 'DELETE'
                return [...acc, item]
            }

            return acc;
        }, [] as DomainFormItem[])

        setDomainNames(updatedDomains)
    }

    return {
        domainNames,
        setDomainNames,
        handleClickSave,
        handleCellValueChanged,
        handleClickAddDomainItem,
        handleClickRemoveDomainItem,
        domainGroup: domainGroup.value,
        setDomainGroup: updateDomainGroup,
    }
}
